import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private codHandlingFeePopupShown: boolean = false;
  // Holds the JSON array of order ids that have already seen the back-press nudge this session.
  private readonly sharePaymentBackPopupKey: string = 'sharePaymentBackPopupSeenOrderIds';
  constructor() {
  }

  getCodHandlingFeePopupState(): boolean {
    return this.codHandlingFeePopupShown;
  }

  setcodHandlingFeePopupShown(): void {
    this.codHandlingFeePopupShown = true;
  }

  // The back-press nudge shows at most once per order for the browser/WebView session;
  // seen order ids are accumulated in a single sessionStorage array.
  getSharePaymentBackPopupState(orderId: string): boolean {
    if (!orderId) return false;
    return this.getSharePaymentBackPopupSeenOrderIds().includes(orderId);
  }

  setSharePaymentBackPopupShown(orderId: string): void {
    if (!orderId) return;
    const seenOrderIds = this.getSharePaymentBackPopupSeenOrderIds();
    if (seenOrderIds.includes(orderId)) return;
    seenOrderIds.push(orderId);
    sessionStorage.setItem(this.sharePaymentBackPopupKey, JSON.stringify(seenOrderIds));
  }

  private getSharePaymentBackPopupSeenOrderIds(): string[] {
    try {
      const stored = sessionStorage.getItem(this.sharePaymentBackPopupKey);
      const parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
